import * as React from 'react';
import { useEffect, useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';

import history from '../../utils/history';
import CircularLoading from '../Common/CircularLoading/CircularLoading';
import CardDetails from './CardDetails';

function SwitchToPaidConfirmModal({
  userSubscription,
  user,
  isOpen,
  onClose,
  activateSubscription,
  subscriptionActivationSucces,
  subscriptionActivationWaiting,
  subscriptionActivationMessage,
}) {
  const [activationSent, setActivationSent] = useState(false);

  useEffect(() => {
    if (
      activationSent &&
      subscriptionActivationSucces &&
      !subscriptionActivationWaiting
    )
      onClose(true);
  }, [subscriptionActivationSucces, subscriptionActivationWaiting]);

  const handleOnClose = () => {
    onClose(false);
  };

  const handleSubmit = () => {
    activateSubscription();
    setActivationSent(true);
  };

  const handleEditPayment = () => {
    history.push('/app/manage-subscription');
    onClose(true);
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={handleOnClose}
      className="confirm-switch-to-paid-popup-content modal-dialog-centered "
      modalClassName="confirm-switch-to-paid-popup"
    >
      <div className="confirm-switch-to-paid-popup-header">
        <div className="title">
          Activate your subscription
          <i className="icon-close" onClick={handleOnClose} />
        </div>
      </div>
      <div className="gradient-divider" />
      <ModalBody className="modal-body">
        {subscriptionActivationWaiting ? (
          <div className="loading-container">
            <CircularLoading className="loading-gif" />
          </div>
        ) : (
          <>
            <div className="title">Payment Method</div>
            <CardDetails userSubscription={userSubscription} user={user} />
            <div className="description">
              If you switch now from a trialing account your trial period ends
              TODAY and you will be charged immediately.
            </div>
            {activationSent &&
              subscriptionActivationMessage &&
              subscriptionActivationMessage.type === 'error' && (
                <div className="message-error">
                  {subscriptionActivationMessage.text}
                </div>
              )}
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <div className="switch-to-paid-confirmation modal-footer-buttons">
          <Button color="error" size="xs" block onClick={handleEditPayment}>
            EDIT PAYMENT DETAILS
          </Button>
          <Button
            className="btn-activate-subscription"
            size="xs"
            block
            onClick={handleSubmit}
          >
            activate subscription
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
}

export default SwitchToPaidConfirmModal;
